
export function DeleteItem(Delete, id, type, list){

    Delete(id)
        .then(() => {
            //console.log(type,"deleted")
            if(list!=undefined){
                list()
            }
        })
        .catch(err => {
            //console.log(err.response)
        })

}